import React from 'react'

const Orders = () => {
  return <h3>Coming very soon</h3>
}

export default Orders
